import React from 'react';
import PropTypes from 'prop-types';
import Button from 'jsx/elements/buttons/Button';
import { withRouter } from 'react-router-dom';

const ButtonBack = ({onClick, history}) => {   
    let onNewClick = () =>{
      if (!onClick){
        if (history){
          history.goBack();
        }        
      }else{
        onClick();
      }
    };
    return (
        <Button text="Til baka" color="gray-light" onClick={onNewClick}></Button> 
      );
};

ButtonBack.propTypes = {
  onClick: PropTypes.func,
  history: PropTypes.object
};
 
export default withRouter(ButtonBack);
